import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import {
  downloadFile,
} from 'containers/App/screens/Foundation/utils/downloadFile';
const {
  NEWTUBE_API_SERVER,
} = url;

// 確認報到
const POST_REGISTER_DATA_REQUEST = 'foundation/hire/POST_REGISTER_DATA_REQUEST';
const POST_REGISTER_DATA_SUCCESS = 'foundation/hire/POST_REGISTER_DATA_SUCCESS';
const POST_REGISTER_DATA_FAIL = 'foundation/hire/POST_REGISTER_DATA_FAIL';

// 列表
const FETCH_HIRELIST_REQUEST = 'Foundation/hire/HIRELIST_REQUEST';
const FETCH_HIRELIST_SUCCESS = 'Foundation/hire/HIRELIST_SUCCESS';
const FETCH_HIRELIST_FAIL = 'Foundation/hire/HIRELIST_FAIL';

// 報到日期

const PUT_HIREDATE_REQUEST = 'Foundation/hire/PUT_HIREDATE_REQUEST';
const PUT_HIREDATE_SUCCESS = 'Foundation/hire/PUT_HIREDATE_SUCCESS';
const PUT_HIREDATE_FAIL = 'Foundation/hire/PUT_HIREDATE_FAIL';

// 繳交文件
const FETCH_REQUIRED_DOCUMENT_REQUEST = 'Foundation/hire/FETCH_REQUIRED_DOCUMENT_REQUEST';
const FETCH_REQUIRED_DOCUMENT_SUCCESS = 'Foundation/hire/FETCH_REQUIRED_DOCUMENT_SUCCESS';
const FETCH_REQUIRED_DOCUMENT_FAIL = 'Foundation/hire/FETCH_REQUIRED_DOCUMENT_FAIL';

const PUT_REQUIRED_DOCUMENT_REQUEST = 'Foundation/hire/PUT_REQUIRED_DOCUMENT_REQUEST';
const PUT_REQUIRED_DOCUMENT_SUCCESS = 'Foundation/hire/PUT_REQUIRED_DOCUMENT_SUCCESS';
const PUT_REQUIRED_DOCUMENT_FAIL = 'Foundation/hire/PUT_REQUIRED_DOCUMENT_FAIL';

// 下載文件
const POST_DOWNLOADFILES_REQUEST = 'Foundation/hire/POST_DOWNLOADFILES_REQUEST';
const POST_DOWNLOADFILES_SUCCESS = 'Foundation/hire/POST_DOWNLOADFILES_SUCCESS';
const POST_DOWNLOADFILES_ERROR = 'Foundation/hire/POST_DOWNLOADFILES_ERROR';

// 未報到 放棄報到
const PUT_GIVEUP_DATA_REQUEST = 'Foundation/hire/PUT_GIVEUP_DATA_REQUEST';
const PUT_GIVEUP_DATA_SUCCESS = 'Foundation/hire/PUT_GIVEUP_DATA_SUCCESS';
const PUT_GIVEUP_DATA_FAIL = 'Foundation/hire/PUT_GIVEUP_DATA_FAIL';

export default function reducer(state = {
  keyword: '',
  datas: [],
  page: {},
  requiredDatas: [],
  requiredPage: {},
  DateDatas: {},
  DatePage: {},
  isFormLoading: false,
  isDateLoading: false,
  isListLoading: false,
  isEmployeeLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_HIRELIST_REQUEST:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    case FETCH_HIRELIST_SUCCESS:
      return Object.assign({}, state, {
        isListLoading: false,
        datas: action.response.data,
        page: action.response.meta,
      });
    case FETCH_HIRELIST_FAIL:
      return Object.assign({}, state, {
        isListLoading: false,
      });

    case FETCH_REQUIRED_DOCUMENT_REQUEST:
      return Object.assign({}, state, {
        isFormLoading: true,
      });
    case FETCH_REQUIRED_DOCUMENT_SUCCESS:
      return Object.assign({}, state, {
        isFormLoading: false,
        requiredDatas: action.response.data,
        requiredPage: action.response.meta,
      });
    case FETCH_REQUIRED_DOCUMENT_FAIL:
      return Object.assign({}, state, {
        isFormLoading: false,
      });
    default:
      return state;
  }
}

/* 首頁列表 */

export function fetchHireList(statusCode) {
  let paramsObject = {};
  if (typeof(statusCode) === 'number') {
    if (statusCode === 20) {
      paramsObject = {
        StartTime: '',
        EndTime: '',
        Currentstatus: 0,
        CurrentStatus: 10,
        currentStatus: 20,
        currentstatus: 30,
        Type: '',
        Value: '',
      };
    } else if (statusCode === 40) {
      paramsObject = {
        StartTime: '',
        EndTime: '',
        CurrentStatus: 40,
        currentStatus: 60,
        Type: '',
        Value: '',
      };
    } else {
      paramsObject = {
        StartTime: '',
        EndTime: '',
        CurrentStatus: statusCode,
        Type: '',
        Value: '',
      };
    }
  } else {
    paramsObject = statusCode;
  }
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}PA/HireList`,
      method: 'GET',
      types: [
        FETCH_HIRELIST_REQUEST,
        FETCH_HIRELIST_SUCCESS,
        FETCH_HIRELIST_FAIL,
      ],
      params: paramsObject,
    },
  };
}

/* 獲取應繳交文件 */

export function fetchRequiredDocument(onboardingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER +
        `PA/HireList/${onboardingId}/RequiredDocument`,
      method: 'GET',
      types: [
        FETCH_REQUIRED_DOCUMENT_REQUEST,
        FETCH_REQUIRED_DOCUMENT_SUCCESS,
        FETCH_REQUIRED_DOCUMENT_FAIL,
      ],
    },
  };
}

/* 修改應繳交文件 */

export function putRequiredDocument(onboardingId, paramsData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER +
        `PA/HireList/${onboardingId}/RequiredDocument`,
      method: 'PUT',
      types: [
        PUT_REQUIRED_DOCUMENT_REQUEST,
        PUT_REQUIRED_DOCUMENT_SUCCESS,
        PUT_REQUIRED_DOCUMENT_FAIL,
      ],
      params: paramsData,
    },
  };
}

/* 修改報到日期 */

export function putHireDate(onboardingId, data) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER +
        `PA/HireList/${onboardingId}/HireDate`,
      method: 'PUT',
      types: [
        PUT_HIREDATE_REQUEST,
        PUT_HIREDATE_SUCCESS,
        PUT_HIREDATE_FAIL,
      ],
      params: data,
    },
  };
}
// 確認報到
export function postRegisterConfirmData(data) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `PA/HireList/TransferPA`,
      method: 'POST',
      types: [
        POST_REGISTER_DATA_REQUEST,
        POST_REGISTER_DATA_SUCCESS,
        POST_REGISTER_DATA_FAIL,
      ],
      params: data,
    },
  };
}

// 下載報表
export function postDownloadFiles(filesArray) {
  const downloadUrl = NEWTUBE_API_SERVER + 'PA/HireList/Files';
  const types = [
    POST_DOWNLOADFILES_REQUEST,
    POST_DOWNLOADFILES_SUCCESS,
    POST_DOWNLOADFILES_ERROR,
  ];
  const params = filesArray;
  const method = 'POST';
  return downloadFile(downloadUrl, types, params, method);
}
/* 未報到 放棄報到 */
export function putGiveUpData(personalId, data) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER +
        `PA/HireList/${personalId}/Status`,
      method: 'PUT',
      types: [
        PUT_GIVEUP_DATA_REQUEST,
        PUT_GIVEUP_DATA_SUCCESS,
        PUT_GIVEUP_DATA_FAIL,
      ],
      params: data,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/screens/RegisterList/reducers/index.js
 **/